import { pillImageBehavior } from '@fluentui/accessibility';
import { getElementType, useUnhandledProps, useAccessibility, useFluentContext, useStyles, useTelemetry } from '@fluentui/react-bindings';
import * as React from 'react';
import { commonPropTypes } from '../../utils';
export var pillImageClassName = 'ui-pill__image';

/**
 * An PillImage is a graphic representation used by Pill.
 */
export var PillImage = /*#__PURE__*/function () {
  var PillImage = /*#__PURE__*/React.forwardRef(function (props, ref) {
    var context = useFluentContext();
    var _useTelemetry = useTelemetry(PillImage.displayName, context.telemetry),
      setStart = _useTelemetry.setStart,
      setEnd = _useTelemetry.setEnd;
    setStart();
    var accessibility = props.accessibility,
      className = props.className,
      design = props.design,
      styles = props.styles,
      variables = props.variables,
      size = props.size;
    var getA11Props = useAccessibility(accessibility, {
      debugName: PillImage.displayName,
      rtl: context.rtl
    });
    var _useStyles = useStyles(PillImage.displayName, {
        className: pillImageClassName,
        mapPropsToStyles: function mapPropsToStyles() {
          return {
            size: size
          };
        },
        mapPropsToInlineStyles: function mapPropsToInlineStyles() {
          return {
            className: className,
            design: design,
            styles: styles,
            variables: variables
          };
        },
        rtl: context.rtl
      }),
      classes = _useStyles.classes;
    var ElementType = getElementType(props);
    var unhandledProps = useUnhandledProps(PillImage.handledProps, props);
    var result = /*#__PURE__*/React.createElement(ElementType, getA11Props('root', Object.assign({
      className: classes.root,
      ref: ref
    }, unhandledProps)));
    setEnd();
    return result;
  });
  PillImage.displayName = 'PillImage';
  PillImage.defaultProps = {
    accessibility: pillImageBehavior,
    as: 'img'
  };
  PillImage.propTypes = Object.assign({}, commonPropTypes.createCommon({
    children: false,
    content: false
  }));
  PillImage.handledProps = Object.keys(PillImage.propTypes);
  PillImage.shorthandConfig = {
    mappedProp: 'src',
    allowsJSX: false
  };
  return PillImage;
}();
//# sourceMappingURL=PillImage.js.map
